"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.LOCAL_FILENAMES = void 0;

var _getIterator2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/get-iterator"));

var _iterator2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/symbol/iterator"));

var _symbol = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/symbol"));

var _from = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/from"));

var _now = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/date/now"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _CordovaFileHelper = _interopRequireDefault(require("../../../../helpers/CordovaFileHelper.js"));

var _config = _interopRequireDefault(require("../../../../../targets/cord_eurofh_teams/config.js"));

var _GameService = _interopRequireDefault(require("./GameService.js"));

var _DataStore = _interopRequireWildcard(require("../../../../KESI2/Stores/DataStore2"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../../helpers/DeviceInfoHelper"));

var _HistoryConsistencyChecker = _interopRequireDefault(require("../../../../helpers/HistoryConsistencyChecker"));

var _BuildConstants = require("../../../../utils/BuildConstants");

var _ThemeActions = _interopRequireDefault(require("../../ThemeStore/ThemeActions2.js"));

var _UserService = _interopRequireDefault(require("./UserService"));

var _RegisterInstance = _interopRequireDefault(require("../../../../KESI2/Services/RegisterInstance"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof _symbol["default"] === "undefined" || o[_iterator2["default"]] == null) { if ((0, _isArray["default"])(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = (0, _getIterator2["default"])(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return (0, _from["default"])(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var jsonPatch = require('fast-json-patch');

var LOCAL_FILENAMES = {
  DATA_FOLDER: 'data',
  QUESTIONS_FILE: 'questions.json',
  HISTORY_FILE: 'history.json'
};
exports.LOCAL_FILENAMES = LOCAL_FILENAMES;
var QUESTION_CHECK_INTERVAL = 86400000; // 60 * 60 * 24 * 1000 -> 24 hours

/*
Formeln: [Object, Object, Object, Object] (4)
Geschichtchen: [Object, Object, Object, Object, Object, Object, Object, Object, Object, Object] (10)
_version: '2019-10-09_16-46-20'
 */

function loadQuestions(_x, _x2) {
  return _loadQuestions.apply(this, arguments);
} //todo: maybe save history to fs too ?


function _loadQuestions() {
  _loadQuestions = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(userAuth, subjectId) {
    var questionsLocal, doesExist, allQuestions, questionsRemote, patch, patchedQuestions, _questionsRemote;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (subjectId) {
              _context.next = 3;
              break;
            }

            console.error("QuizOfflineHelper loadQuestions: missing subjectId");
            return _context.abrupt("return");

          case 3:
            questionsLocal = null;
            _context.next = 6;
            return _CordovaFileHelper["default"].folderExists(LOCAL_FILENAMES.DATA_FOLDER);

          case 6:
            doesExist = _context.sent;

            if (doesExist) {
              _context.next = 12;
              break;
            }

            _context.next = 10;
            return _CordovaFileHelper["default"].createFolder(LOCAL_FILENAMES.DATA_FOLDER);

          case 10:
            _context.next = 15;
            break;

          case 12:
            _context.next = 14;
            return loadQuestionsFromFs(subjectId);

          case 14:
            questionsLocal = _context.sent;

          case 15:
            allQuestions = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_ALL_QUESTIONS) || {};

            if (questionsLocal) {
              _context.next = 23;
              break;
            }

            _context.next = 19;
            return loadQuestionsFromRemote(userAuth);

          case 19:
            questionsRemote = _context.sent;

            if (questionsRemote) {
              allQuestions[subjectId] = questionsRemote;
              writeQuestionFileToFs(questionsRemote);
            } else {
              console.error('QuizOfflineHelper loadQuestions: local and remote questionFile load failed.');
            }

            _context.next = 37;
            break;

          case 23:
            if (!_DeviceInfoHelper["default"].isOnline()) {
              allQuestions[subjectId] = questionsLocal;
            }

            _context.next = 26;
            return getQuestionPatch(userAuth, questionsLocal._version);

          case 26:
            patch = _context.sent;

            if (!(patch && (0, _isArray["default"])(patch))) {
              _context.next = 32;
              break;
            }

            patchedQuestions = applyQuestionPatch(questionsLocal, patch);

            if (patchedQuestions) {
              allQuestions[subjectId] = patchedQuestions;
              writeQuestionFileToFs(patchedQuestions); // return
            } else {
              //todo: should be redownload everything here too or use local questions ?
              allQuestions[subjectId] = questionsLocal;
            }

            _context.next = 37;
            break;

          case 32:
            _context.next = 34;
            return loadQuestionsFromRemote(userAuth);

          case 34:
            _questionsRemote = _context.sent;
            console.info('QuizOfflineHelper Getting QuestionPatch failed, will try to download everything');

            if (_questionsRemote) {
              allQuestions[subjectId] = _questionsRemote;
              writeQuestionFileToFs(_questionsRemote);
            } else {
              console.error('QuizOfflineHelper loadQuestions: questionPatch and remote questionFile load failed.'); // If everything failed we can still use our local questions

              allQuestions[subjectId] = questionsLocal;
            }

          case 37:
            _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_ALL_QUESTIONS, allQuestions);

          case 38:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadQuestions.apply(this, arguments);
}

function loadHistory(_x3, _x4) {
  return _loadHistory.apply(this, arguments);
}

function _loadHistory() {
  _loadHistory = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(userAuth, subjectId) {
    var path, answersToBeSend, resp, newHistory, rubric, historyMap, _iterator, _step, question, history;

    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            // do not get history when we still have answers to send to server, otherwise response from server is corrupted
            path = "".concat(_DataStore.DATA_STORE_PATHS.QD_ANSWERS_OFFLINE, ".").concat(subjectId);
            answersToBeSend = _DataStore["default"].getElementByPathImmediately(path);

            if (!(answersToBeSend && answersToBeSend.length > 0)) {
              _context2.next = 4;
              break;
            }

            return _context2.abrupt("return");

          case 4:
            _context2.next = 6;
            return loadHistoryFromRemote(userAuth);

          case 6:
            resp = _context2.sent;

            if (resp && resp.success) {
              newHistory = {};

              for (rubric in resp.rubrics) {
                historyMap = {};
                _iterator = _createForOfIteratorHelper(resp.rubrics[rubric]);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    question = _step.value;
                    historyMap[question.question] = question;
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                newHistory[rubric] = historyMap;
              }

              history = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_ALL_HISTORY) || {}; // @ts-ignore

              if (history[subjectId] && _BuildConstants.NODE_ENV !== 'production') {
                _HistoryConsistencyChecker["default"].checkConsistency(newHistory, history[subjectId]);
              }

              history[subjectId] = newHistory;

              _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_ALL_HISTORY, history);
            }

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _loadHistory.apply(this, arguments);
}

function loadTheme() {
  var groupObject = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_GROUP);

  if (groupObject) {
    var jsonTheme = JSON.parse(groupObject.value.theme);

    _ThemeActions["default"].addTheme(jsonTheme);
  }
}

function writeQuestionFileToFs(_x5) {
  return _writeQuestionFileToFs.apply(this, arguments);
}

function _writeQuestionFileToFs() {
  _writeQuestionFileToFs = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(questionFile) {
    var subjectId;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            subjectId = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_SUBJECT_ID);
            _context3.next = 4;
            return _CordovaFileHelper["default"].writeToFile((0, _stringify["default"])(questionFile), "".concat(subjectId).concat(LOCAL_FILENAMES.QUESTIONS_FILE), LOCAL_FILENAMES.DATA_FOLDER);

          case 4:
            return _context3.abrupt("return", true);

          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](0);
            console.error('QuizOfflineHelper loadQuestions: ', _context3.t0);
            return _context3.abrupt("return", false);

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 7]]);
  }));
  return _writeQuestionFileToFs.apply(this, arguments);
}

function loadQuestionsFromFs(_x6) {
  return _loadQuestionsFromFs.apply(this, arguments);
}

function _loadQuestionsFromFs() {
  _loadQuestionsFromFs = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(subjectId) {
    var questionsText;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return _CordovaFileHelper["default"].readTextFile("".concat(subjectId).concat(LOCAL_FILENAMES.QUESTIONS_FILE), LOCAL_FILENAMES.DATA_FOLDER);

          case 3:
            questionsText = _context4.sent;
            return _context4.abrupt("return", JSON.parse(questionsText));

          case 7:
            _context4.prev = 7;
            _context4.t0 = _context4["catch"](0);
            console.info('Unable to read question File from fs. Will try remote. ', _context4.t0);
            return _context4.abrupt("return", null);

          case 11:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 7]]);
  }));
  return _loadQuestionsFromFs.apply(this, arguments);
}

function loadQuestionsFromRemote(_x7) {
  return _loadQuestionsFromRemote.apply(this, arguments);
}

function _loadQuestionsFromRemote() {
  _loadQuestionsFromRemote = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(userAuth) {
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return _GameService["default"].getAllQuestionsForUser(userAuth);

          case 3:
            return _context5.abrupt("return", _context5.sent);

          case 6:
            _context5.prev = 6;
            _context5.t0 = _context5["catch"](0);
            console.error('QuizOfflineHelper loadQuestionsFromRemote ', _context5.t0);
            return _context5.abrupt("return", null);

          case 10:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 6]]);
  }));
  return _loadQuestionsFromRemote.apply(this, arguments);
}

function loadHistoryFromFs() {
  return _loadHistoryFromFs.apply(this, arguments);
}

function _loadHistoryFromFs() {
  _loadHistoryFromFs = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
    var history;
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return _CordovaFileHelper["default"].readTextFile(LOCAL_FILENAMES.HISTORY_FILE, LOCAL_FILENAMES.DATA_FOLDER);

          case 3:
            history = _context6.sent;
            return _context6.abrupt("return", JSON.parse(history));

          case 7:
            _context6.prev = 7;
            _context6.t0 = _context6["catch"](0);
            console.info('Unable to read history from fs. Will try remote. ', _context6.t0);
            return _context6.abrupt("return", null);

          case 11:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 7]]);
  }));
  return _loadHistoryFromFs.apply(this, arguments);
}

function loadHistoryFromRemote(_x8) {
  return _loadHistoryFromRemote.apply(this, arguments);
}

function _loadHistoryFromRemote() {
  _loadHistoryFromRemote = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(userAuth) {
    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            _context7.next = 3;
            return _GameService["default"].getFullHistoryForUser(userAuth);

          case 3:
            return _context7.abrupt("return", _context7.sent);

          case 6:
            _context7.prev = 6;
            _context7.t0 = _context7["catch"](0);
            console.error('QuizOfflineHelper loadHistoryFromRemote ', _context7.t0);
            return _context7.abrupt("return", null);

          case 10:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[0, 6]]);
  }));
  return _loadHistoryFromRemote.apply(this, arguments);
}

function applyQuestionPatch(questionFile, patch) {
  try {
    return jsonPatch.applyPatch(questionFile, patch, true, false).newDocument;
  } catch (error) {
    console.error('QuizOfflineHelper applyQuestionPatch ', error);
    return null;
  }
}

function getQuestionPatch(_x9, _x10) {
  return _getQuestionPatch.apply(this, arguments);
}

function _getQuestionPatch() {
  _getQuestionPatch = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(userAuth, version) {
    return _regenerator["default"].wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            _context8.next = 3;
            return _GameService["default"].getPatchForQuestions(userAuth, version);

          case 3:
            return _context8.abrupt("return", _context8.sent);

          case 6:
            _context8.prev = 6;
            _context8.t0 = _context8["catch"](0);
            console.error('QuizOfflineHelper getQuestionPatch ', _context8.t0);
            return _context8.abrupt("return", null);

          case 10:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[0, 6]]);
  }));
  return _getQuestionPatch.apply(this, arguments);
}

function sendAnswersToServer(_x11, _x12) {
  return _sendAnswersToServer.apply(this, arguments);
}

function _sendAnswersToServer() {
  _sendAnswersToServer = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(userAuth, subjectId) {
    var learningStatePath, learningState, answerPath, answers, postObj, response, rubrics, i, _response, _rubrics;

    return _regenerator["default"].wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            if (subjectId) {
              _context9.next = 2;
              break;
            }

            throw "QuizOfflineHelper: sendAnswersToServer missing subjectId";

          case 2:
            learningStatePath = "".concat(_DataStore.DATA_STORE_PATHS.QD_LEARNING_STATE_OFFLINE, ".").concat(subjectId);
            learningState = _DataStore["default"].getElementByPathImmediately(learningStatePath);
            answerPath = "".concat(_DataStore.DATA_STORE_PATHS.QD_ANSWERS_OFFLINE, ".").concat(subjectId);
            answers = _DataStore["default"].getElementByPathImmediately(answerPath);

            if (!(!learningState || !answers || answers.length === 0)) {
              _context9.next = 9;
              break;
            }

            console.info('QuizOfflineHelper sendAnswersToServer: missing values ', learningState, answers);
            return _context9.abrupt("return");

          case 9:
            if (!_config["default"].sendSinglePlayerQuestionsAsBulk) {
              _context9.next = 25;
              break;
            }

            _context9.prev = 10;
            postObj = {
              answers: answers
            };
            _context9.next = 14;
            return _GameService["default"].postRound(postObj, userAuth);

          case 14:
            response = _context9.sent;
            rubrics = response.rubrics;
            rubrics.forEach(function (rubric) {
              // const rubricName = rubric.name.replace(/[^a-zA-Z0-9]+/g, '')
              var rubricName = rubric.name;
              learningState[rubricName].inProgess = rubric.inProgess;
              learningState[rubricName].learned = rubric.learned;
              learningState[rubricName].questionCount = rubric.questionCount;
              /*
              newCategories[subjectId] = newCategories.map((category: subjectObject) => {
                return (category.name === rubric.name) ? rubric : category
              })
               // @ts-ignore
              if (NODE_ENV !== 'production' && newLearningState[rubricName]) {
                LearningStateConsistencyChecker.checkConsistency(rubric, learningState[rubricName])
              }
               */
            });
            answers.splice(0, answers.length);
            _context9.next = 23;
            break;

          case 20:
            _context9.prev = 20;
            _context9.t0 = _context9["catch"](10);
            console.error('QuizOfflineHelper sendRoundToServer: Unable to send round to server ', _context9.t0);

          case 23:
            _context9.next = 44;
            break;

          case 25:
            i = answers.length - 1;

          case 26:
            if (!(i >= 0)) {
              _context9.next = 44;
              break;
            }

            _context9.prev = 27;
            _context9.next = 30;
            return _GameService["default"].postAnswer(answers[i], userAuth);

          case 30:
            _response = _context9.sent;

            if (_response.success) {
              _context9.next = 33;
              break;
            }

            return _context9.abrupt("continue", 41);

          case 33:
            _rubrics = _response.rubrics;

            _rubrics.forEach(function (rubric) {
              var rubricName = rubric.name;
              learningState[rubricName].inProgess = rubric.inProgess;
              learningState[rubricName].learned = rubric.learned;
              learningState[rubricName].questionCount = rubric.questionCount;
            });

            _context9.next = 41;
            break;

          case 37:
            _context9.prev = 37;
            _context9.t1 = _context9["catch"](27);
            console.error('QuizOfflineHelper sendAnswersToServer: Unable to send answers to server ', _context9.t1);
            return _context9.abrupt("break", 44);

          case 41:
            i--;
            _context9.next = 26;
            break;

          case 44:
            _context9.next = 46;
            return _DataStore["default"].setSingleData(learningStatePath, learningState);

          case 46:
            _context9.next = 48;
            return _DataStore["default"].setSingleData(answerPath, answers);

          case 48:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[10, 20], [27, 37]]);
  }));
  return _sendAnswersToServer.apply(this, arguments);
}

function init(_x13, _x14) {
  return _init.apply(this, arguments);
}
/**
 * Exporting specific functions and keeping QuizOfflineHelper namespace
 */


function _init() {
  _init = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(subjectId, subjectsLearningState) {
    var isInitializedObj, lastPatchCheck, nowTimeStamp, isOlderThan24Hours, token, userAuth, subjects, learningState;
    return _regenerator["default"].wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            loadTheme();

            if (subjectId) {
              _context10.next = 3;
              break;
            }

            throw "QuizOfflineHelper init: missing subjectId";

          case 3:
            isInitializedObj = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_OFFLINE_IS_INITIALIZED) || {};
            lastPatchCheck = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_LAST_OFFLINE_QUESTION_CHECK_TIMESTAMP) || 0;
            nowTimeStamp = (0, _now["default"])();
            isOlderThan24Hours = nowTimeStamp - lastPatchCheck > QUESTION_CHECK_INTERVAL;

            if (!(isInitializedObj && isInitializedObj[subjectId] && !isOlderThan24Hours)) {
              _context10.next = 9;
              break;
            }

            return _context10.abrupt("return");

          case 9:
            _context10.next = 11;
            return _RegisterInstance["default"].getAccessToken('quizUser:read quizUser:write quizGroup:read quizGame:read quizGame:write');

          case 11:
            token = _context10.sent;
            userAuth = "Bearer ".concat(token);
            _context10.prev = 13;

            if (!_DeviceInfoHelper["default"].isOnline()) {
              _context10.next = 27;
              break;
            }

            _context10.next = 17;
            return sendAnswersToServer(userAuth, subjectId);

          case 17:
            _context10.next = 19;
            return loadHistory(userAuth, subjectId);

          case 19:
            _context10.next = 21;
            return _GameService["default"].getCategories(userAuth);

          case 21:
            subjects = _context10.sent;
            _context10.next = 24;
            return _UserService["default"].loadLearningStates(userAuth, true);

          case 24:
            learningState = _context10.sent;

            if (learningState) {
              subjectsLearningState[subjectId] = learningState;

              _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_LEARNING_STATE_OFFLINE, subjectsLearningState);
            }

            _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_CATEGORIES_OFFLINE, subjects);

          case 27:
            _context10.next = 32;
            break;

          case 29:
            _context10.prev = 29;
            _context10.t0 = _context10["catch"](13);
            console.error('QuizOfflineHelper init: ', _context10.t0);

          case 32:
            _context10.prev = 32;
            _context10.next = 35;
            return loadQuestions(userAuth, subjectId);

          case 35:
            isInitializedObj[subjectId] = true;

            _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_OFFLINE_IS_INITIALIZED, isInitializedObj, false);

            _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_LAST_OFFLINE_QUESTION_CHECK_TIMESTAMP, (0, _now["default"])());

            return _context10.finish(32);

          case 39:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[13, 29, 32, 39]]);
  }));
  return _init.apply(this, arguments);
}

var QuizOfflineHelper = {
  init: init,
  sendAnswersToServer: sendAnswersToServer
};
var _default = QuizOfflineHelper;
exports["default"] = _default;